<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.cardNo"
        placeholder="卡号"
        style="width: 150px;"
        class="filter-item"
      />
      <el-select
        v-model="listQuery.isUsed"
        :placeholder="$t('card.usedStatus')"
        style="width: 150px;margin-left: 20px"
        class="filter-item"
      >
        <el-option label="全部" value="-1"/>
        <el-option v-for="(item,index) in statusTypes" :key="index" :label="item" :value="index"/>
      </el-select>
      <el-button
        v-waves
        class="filter-item"
        style="margin-left: 20px"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
      >{{ $t('table.search') }}</el-button>
    </div>
    <el-table
      v-loading="listLoading"
      :key="tableKey"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%;"
    >
      <el-table-column label="卡号" align="center" width="140%">
        <template slot-scope="scope">
          <span>{{ scope.row.cardNo }}</span>
        </template>
      </el-table-column>
      <!--      <el-table-column :label="$t('card.phyCardNo')" align="center" width="140%">
        <template slot-scope="scope">
          <span>{{ scope.row.phyCardNo }}</span>
        </template>
      </el-table-column>-->
      <el-table-column :label="$t('card.groupName')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.groupName }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('card.stationName')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.stationName }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('card.usedStatus')" align="center" width="100%">
        <template slot-scope="scope">
          <span>{{ scope.row.isUsed | statusFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('card.createdTime')" align="center" min-width="140px">
        <template slot-scope="scope">
          <span>{{ scope.row.createdTime }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('card.updatedTime')" align="center" min-width="140px">
        <template slot-scope="scope">
          <span>{{ scope.row.updatedTime }}</span>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.pi"
        :page-sizes="[10,20,30,50]"
        :page-size="listQuery.ps"
        :total="total"
        background
        layout="total, sizes, prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { cardList } from '@/api/setting'
import waves from '@/directive/waves' // 水波纹指令
const statusTypes = { '0': '未使用', '1': '已使用' }
const statusMap = { 0: '未使用', 1: '已使用' }
export default {
  name: 'List',
  directives: {
    waves
  },
  filters: {
    statusFilter (status) {
      return statusMap[status + '']
    },
    typeFilter (type) {
    }
  },
  data () {
    return {
      tableKey: 0,
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        pi: 1,
        ps: 20,
        isUsed: '-1',
        cardNo: ''
      },
      statusTypes: statusTypes
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {
      this.listLoading = true
      cardList(this.listQuery).then(response => {
        const row = response.data
        if (row.data) {
          this.list = row.data.items
          this.total = row.data.totalItems
        }
        this.listLoading = false
      })
    },
    handleFilter () {
      this.listQuery.pi = 1
      this.getList()
    },
    handleSizeChange (val) {
      this.listQuery.ps = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.listQuery.pi = val
      this.getList()
    }
  }
}
</script>
